import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WhatsAppWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  border-radius: 50%;
  background: green;
  width: 50px;
  height: 50px;
  svg {
    width: 30px;
    height: 30px;
  }
  @media (min-width: 768px) {
    width: 75px;
    height: 75px;
    svg {
      width: 50px;
      height: 50px;
    }
  }
`;

export const ScrollToTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 120px;
  right: 33px;
  z-index: 1000;
  border-radius: 5px;
  background: var(--primary);
  padding: 12px;
  transition: all 0.3s ease;
  span {
    display: none;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  svg {
    width: 15px;
    height: 15px;
    transition: opacity 0.3s ease;
  }
  @media (min-width: 768px) {
    svg {
      width: 30px;
      height: 30px;
    }
  }
  &:hover {
    cursor: pointer;
    box-shadow: 2px 2px 5px white;
    right: 10px;
    svg {
      opacity: 0;
      display: none;
    }
    span {
      display: block;
      opacity: 1;
      color: white;
      font-size: 16px;
      font-weight: 500;
    }
  }
`;
